export const uk = {
  // Nav
  "Notifications": "Сповіщення",
  "More": "Ще",
  "Logout": "Вийти",
  "NoNotifications": "Немає сповіщень",
  // Mobile Timesheets
  "WeekTotal": "Разом за тиждень",
  "entries": "записів",
  "Weekend": "Вихідний",
  "AddEntry": "Додати запис",
  "SendForApproval": "Надіслати на погодження",
  "NoEntriesDay": "Немає записів за цей день",
  "EditEntry": "Редагувати запис",
  "NewEntry": "Новий запис",
  "CategoryTask": "Категорія та завдання",
  "WhatDidYouDo": "Що ви робили…",
  "Draft": "Чернетка",
  "Fulfilled": "Погоджено",
  "Rejected": "Відхилено",
  "SelectTask": "Оберіть завдання",
  "EnterTime": "Вкажіть час початку та завершення",
  "EndAfterStart": "Час завершення має бути після початку",
  "EntryUpdated": "Запис оновлено",
  "EntryAdded": "Запис додано",
  "SaveError": "Помилка збереження",
  "ConfirmDelete": "Видалити цей запис?",
  "DeleteError": "Помилка видалення",
  "SentForApproval": "Надіслано на погодження",
  "WeekReturned": "Тиждень повернено в чернетку",
  "SendWeekTitle": "Надіслати тиждень на погодження?",
  "SendWeekWarning": "Весь тиждень буде надіслано керівнику на погодження. Ви не зможете редагувати записи до перевірки.",
  "hShort": "год",
  "mShort": "хв",
  // Mobile Dashboard
  "Hi": "Привіт",
  "Worked": "Відпрацьовано",
  "OnApproval": "На погодженні",
  "TOILBalance": "Баланс TOIL",
  "News": "Новини",
  "NoNews": "Немає новин",
  // Mobile Equipment
  "PATtest": "PAT-тест",
  "Capitalised": "Капіталізовано",
  "Warranty": "Гарантія",
  "Notes": "Нотатки",
  "NoEquipment": "Немає обладнання",
  // Mobile Documents
  "OpenDocument": "Відкрити документ",
  "Acknowledge": "Підтвердити",
  "NoDocuments": "Немає документів",
  "Type": "Тип",
  "Added": "Додано",
  // Mobile sections (Finance/HR/CRM/Training/Booking/Tasks/Community)
  "OnHold": "Призупинено",
  "Completed": "Завершено",
  "Archived": "Архів",
  "NoData": "Нічого не знайдено",
  "Approved": "Погоджено",
  "Paid": "Оплачено",
  "NoExpenses": "Немає витрат",
  "AbsentToday": "Сьогодні відсутні",
  "Employees": "Співробітники",
  "InProgress": "У процесі",
  "NotStarted": "Не розпочато",
  "NoCourses": "Немає курсів",
  "Pages": "сторінок",
  "Questions": "запитань",
  "PassThreshold": "Прохідний бал",
  "Score": "Результат",
  "My": "Мої",
  "Rooms": "Кімнати",
  "Seats": "місць",
  "NoBookings": "Немає бронювань",
  "Done": "Виконано",
  "High": "Високий",
  "Medium": "Середній",
  "Low": "Низький",
  "NoTasks": "Немає задач",
  "Due": "Термін",
  "Rental": "Оренда",
  "NoEntriesWeek": "Немає записів за тиждень",
  "Timesheets": "Табели",
  "Reports": "Звіти",
  "Approve": "Схвалити",
  "Approvals": "Погодження",
  "Clients": "Клієнти",
  "Equipment": "Обладнання",
  "Booking": "Бронювання",
  "Expenses": "Витрати",
  "Orders": "Замовлення",
  "Admin": "Адміністрування",
  "Users": "Користувачі",
  "Toil": "Відпочинок",
  "UsersReports": "Звіти-користувачі",
  // Header menu 
  "Setting": "Налаштування",
  "Profile": "Профіль",
  "LogOut": "Вийти",
  "RailSummary": "Розумний підсумок",
  "RailSchedule": "Розклад",
  "RailManage": "Панель керування",
  "Login": "Увійти",
  "Search": "Пошук...",
  "Filter": "Фільтр",
  "AddFilter": "Додати фільтр",
  "SearchOrFilter": "Пошук або фільтр…",
  "Remove": "Прибрати",
  "Notification": "Сповіщення",
  // Report table 
  "Date": "Дата",
  "StartTime": "Початок",
  "EndTime": "Кінець",
  "Category": "Категорія",
  "CategoryNew": "Категорія ★",
  "Task": "Завдання",
  "Description": "Опис",
  "Supervisor": "Супервізор",
  "Hours": "Години",
  "Edit": "Редагувати",
  "Download": "Завантажити",
  "AreYouSureDownload": "Ви впевнені, що хочете завантажити цей звіт?",
  "ReportList": "Список звітів",
  // Aprove Table 
  "TotalUserHours": "Загальна кількість годин користувача",
  "TotalCategoryHours": "Загальна кількість годин за категорією",
  "Name": "Ім'я",
  "Total": "Всього",
  "ApproveAll": "Підтвердити всі",
  "Return": "Повернути",
  "ApproveAllForWeek": "Підтвердити тиждень",
  "TotalWeek": "Всього за тиждень",
  "RemoveAllForWeek": "Вернути тиждень",
  "AreYouSureBack": "Ви дійсно хочете вернути весь тиждень?",
  "RejectMessage": "Введіть причину відхилення",
  "ApproveList": "Список підтверджень",
  // Timesheets 
  "AreYouSureReport": "Ви впевнені, що хочете надіслати щотижневий звіт?",
  "Add": "Додати",
  "SendTo": "Надіслати на схвалення",
  "SelectUsers": "Вибрати Користувача",
  "ReturnWeek": "Повернути Тиждень",
  "ResubmitRejected": "Повторно надіслати відхилені",
  "SelectTemplate": "Вибрати шаблон",
  "PerWee": "За тиждень",
  "TOIL": "TOIL",
  "TimesheetsList": "Список Табелів",
  "AddReport": "Додати Звіт",
  "CreateWeekTemplate": "Створити шаблон тижня",
  "ThisWeek": "Цей тиждень",
  "SelectCategory": "Оберіть категорію...",
  "DescriptionPoins": "Опис...",
  "AreYouSureBackWeek": "Ви впевненний що хочете повернути цей тижден?",
  // Expenses
  "AreYouSureChangeStatus": "Ви впевнені, що хочете змінити",
  "AccountNumber": "Номер рахунку",
  "FinanceAdditionalInfo": "Додаткова фінансова інформація:",
  "Visible fields": "Видимі поля",
  "Hidden fields": "Приховані поля",
  "StatusExp": "статус(и)",
  "to": "на",
  "StatusExpense": "Статус",
  "AddExpenses": "Додати витрати",
  "CreateExpenseClaim": "Створити нову заявку на витрати",
  "AddIncomeSub": "Додати новий запис доходу",
  "AddCarExpenseSub": "Додати новий запис витрат на авто",
  "Exenses List": "Список витрат",
  "NameCreator": "Ім'я створювача",
  "Staff": "Персонал",
  "Amount": "Сума",
  "Phone": "Телефон",
  "AddUserInfo": "Додати інфо про користувача",
  "Project": "Проєкт",
  "ExensesList": "Список витрат",
  "ExpensesList": "Список витрат",
  "Period": "Період",
  "Time": "Час",
  "BrowsePaymant": "Завантажити платіж",
  "BrowsePayment": "Завантажити платіж",
  "Payment": "Платіж",
  "Car": "Авто",
  "Cars": "Автомобілі",
  "Distance": "Відстань",
  "Purpose": "Призначення",
  "AddCarExpenses": "Додати витрати на авто",
  "AdditionalInfo": "Додаткова інформація",
  "Brand": "Марка",
  "PlateNumber": "Номерний знак",
  "Year": "Рік",
  "Mileage": "Пробіг",
  "Doc": "Документ",
  "FuelType": "Тип пального",
  "AvgFuelConsumption": "Середня витрата пального",
  "CostPerKm": "Вартість за",
  "Vin": "VIN",
  "InsuranceProvider": "Страхова компанія",
  "InsuranceExpiryDate": "Дата закінчення страхування",
  "InsurancePolicyNumber": "Номер страхового полісу",
  "BrowseInsurance": "Завантажити страхування",
  "UsageType": "Тип використання",
  "EditCars": "Редагувати авто",
  "CarsInfo": "Інформація про авто",
  "Active": "Активно",
  "AddCars": "Додати Авто",
  "Destination": "Місце призначення",
  "ExensesCarsList": "Список витрат на авто",
  "CarExpensesList": "Список витрат на авто",
  "EstimatedCost": "Орієнтовна вартість",
  "StaffToggleHint": "Вимкніть, щоб додати банківські реквізити одержувача",
  "NoExpensesAvailable": "Витрат за обраний період не знайдено",
  "NoCarExpensesAvailable": "Витрат на авто за обраний період не знайдено",
  "FillRequiredFields": "Заповніть обов'язкові поля",
  "ChooseAmount": "Вкажіть суму",
  "AmountInvalidEnd": "Сума не може закінчуватись крапкою або комою",
  "UploadFileRequired": "Будь ласка, завантажте платіжний документ",
  "FileSizeLimit": "Розмір файлу повинен бути менше 2МБ",
  "ChooseCategory": "Оберіть категорію",
  "ChooseCars": "Оберіть автомобіль",
  "StartingPointRequired": "Вкажіть місце відправлення",
  "DestinationRequired": "Вкажіть місце призначення",
  "PurposeRequired": "Вкажіть призначення поїздки",
  "DistanceRequired": "Відстань повинна бути більше 0",
  "RejectionReason": "Причина відмови",
  "RejectionReasonPlaceholder": "Будь ласка, вкажіть причину відмови...",
  "Confirm": "Підтвердити",
  "LicenseExpired": "Термін дії водійського посвідчення закінчився",
  "LicenseExpiringSoon": "Термін дії водійського посвідчення незабаром закінчується",
  "InsuranceInfo": "Інформація про страхування",
  "CostCar": "Вартість авто",
  "OtherInfo": "Інша інформація",
  "DriverLicense": "Водійське посвідчення",
  "LicenseExpiryDate": "Термін дії посвідчення",
  "DriverLicenseInfo": "Інформація про водійське посвідчення",
  "BrowseLicense": "Завантажити посвідчення",
  "LicenseNumber": "Номер посвідчення",
  "VehicleClass": "Категорія ТЗ",
  "IssueDate": "Дата видачі",
  "PhotoFront": "Фото (лицьова сторона)",
  "PhotoBack": "Фото (зворотна сторона)",
  "SaveLicense": "Зберегти посвідчення",
  "ClickToUpload": "Натисніть для завантаження",
  "MotExpiryDate": "Термін дії MOT",
  "BrowseMot": "Завантажити MOT",
  // Equipment
  "Import": "Імпортувати",
  "AreYouSureEquipment": "Ви впевнені, що хочете завантижити цей зразок?",
  "AreYouSureEquipmentAll": "Ви впевнені, що хочете завантижити вибране обладнання?",
  "AddEqp": "Додати Обладнання",
  "EqpList": "Список обладнання",
  "InventoryList": "Список Інвентаризації",
  "PatTestList": "Список PAT-Тестів",
  "Number": "Номер",
  "Item": "Предмет",
  "Items": "записів",
  "Manufacturer": "Виробник",
  "Model": "Модель",
  "SerialNumber": "Серійний номер",
  "Responsive": "Відповідальний",
  "PurchaseDate": "Дата придбання",
  "Cost": "Ціна придбання",
  "PATTestDate": "Дата PAT-тесту",
  "PATTestDue": "Термін PAT-тесту",
  "PATTestUser": "Користувач PAT-тесту",
  "Note": "Примітка",
  "ResponsibleForItem": "Відповідальний за предмет:",
  "WarrantyDue": "Гарантія до",
  "ItemInfo": "Інформація про предмет",
  "PATInfo": "Інформація про PAT",
  "ResponsibleForPAT": "Відповідальний за PAT",
  "EditEquipment": "Редагувати обладнання",
  "Eqp": "Обладнання",
  "RentalOpportunity": "Можливість оренди",
  "InventoryID": "Ідентифікатор інвентарю",
  "EditEqp": "Редагувати обладнання",
  "InventoryDate": "Дата інвентаризації",
  "InventoryUser": "Користувач інвентаризації",
  "InventoryInfo": "Інформація про інвентаризацію",
  "SelectTheNumberOfMonths": "Виберіть кількість місяців",
  "Selected": "вибрано",
  "SelectAll": "Виділити все",
  //Template
  "Template": "Шаблон",
  "Temp": "Шаблона",
  "мaximum20characters": "максимум 20 символів",
  "CreateNew": "Створити Новий",
  "MyTemplates": "Мої Шаблони",
  "EditTemp": "Редагувати Шаблон",
  "To": "до",
  "AddTempate": "Додати шаблон",
  "ChooseUser": "Виберіть Користувача",
  "CreateWeekTempate": "Створити шаблон тижня",
  "AddNewTemplate": "Додати Новий Шаблон",
  "Tempate": "Шаблон",
  "AddTo": "Додати до",
  "Empty": "Пусто",
  "NoAccess": "Немає доступу",
  "StatusUpdateFailed": "Не вдалося змінити статус. Спробуйте ще раз",
  "NoAccessHint": "Ваша роль не дозволяє цей розділ. Зверніться до адміністратора",
  "InsertTemp": "Вставити цей шаблон в репорт?",
  //Docs
  "AddDocs": "Додати Документ",
  "AddDocument": "Додати Документ",
  "EditDocument": "Редагувати Документ",
  "CreateDoc": "Створити документ",
  "UploadFile": "Завантажити файл",
  "HowAddDoc": "Як ви хочете додати документ?",
  "OpenEditorHint": "Відкрити редактор і написати документ",
  "UploadFileHint": "PDF · до 1 МБ",
  "CreateOrUploadHint": "Створіть або завантажте документ і виберіть, хто має ознайомитися",
  "CreateOrUpload": "Створіть документ або завантажте файл",
  "EmptyDocument": "Документ порожній",
  "OnlyPdf": "Лише PDF",
  "StartWriting": "Почніть писати документ…",
  "NewDocument": "Новий документ",
  "NoDocumentSelected": "Документ не вибрано",
  "EditorDraft": "Редактор · чернетка",
  "CurrentFile": "Поточний файл",
  "ReplaceFile": "Замінити",
  "OpenToReadSign": "Подвійний клік — читати та підписати",
  "Text": "Текст",
  "select": "вибрати",
  "Title": "Заголовок",
  "Discription": "Опис",
  "Info": "Інформація",
  "ViewDoc": "Перегляд",
  "Informed": "Ознайомлені",
  "AddFile": "Додати файл",
  "AllUsers": "Усі користувачі",
  "ChooseUsers": "Обрати користувачів",
  "DayLearn": "Термін ознайомлення",
  "Review": "Прийняти",
  "StatusDoc": "Статус",
  "CategoryList": "Список Категорій",
  "DoYouReallyWantToReviewThisDocument": "Я прочитав(ла), зрозумів(ла) і погоджуюсь із положеннями Політик",
  "DoYouReallyWantToDeleteThisDocument?": "Ви дійсно хочете видалити цей документ?",
  // Docs — Variant 5 grid
  "Filters": "Фільтри",
  "FileType": "Тип файлу",
  "AllStatuses": "Усі статуси",
  "PolicyStatusNotAssigned": "Не призначено",
  "PolicyStatusPending": "Очікує",
  "PolicyStatusAcknowledged": "Підтверджено",
  "PolicyBtnAcknowledge": "Підтвердити",
  "CardsView": "Картки",
  "SignedOff": "Ознайомлення",
  "Signed": "Ознайомлені",
  "Pending": "Очікують",
  "Deadline": "Дедлайн",
  "ClearAll": "Очистити все",
  "AllCategories": "Усі категорії",
  "Days": "дн.",
  // Booking
  "BookingCalendar": "Календар бронювань",
  "NoBookingsAvailable": "Немає бронювань",
  "CalendarView": "Календар",
  "ListView": "Список",
  "AddBooking": "Додати бронювання",
  "EditBooking": "Редагувати бронювання",
  "DeleteBooking": "Видалити бронювання",
  "BookedFor": "Забронювано для",
  "PrevMonth": "Попередній місяць",
  "NextMonth": "Наступний місяць",
  "AllResources": "Всі",
  "EquipmentOnly": "Обладнання",
  "RoomsOnly": "Кімнати",
  "SearchResources": "Пошук обладнання / кімнат...",
  "FilterByType": "Тип",
  "FilterByUser": "Забронювано для",
  "ResetFilters": "Скинути",
  "BookingOverlapError": "Цей ресурс вже заброньований на вибраний період",
  "ResourceType": "Тип ресурсу",
  "SelectEquipment": "Оберіть обладнання",
  "SelectRoom": "Оберіть кімнату",
  "BookingNotes": "Нотатки (необов'язково)",
  "ManageRooms": "Кімнати",
  "AddRoom": "Додати кімнату",
  "EditRoom": "Редагувати кімнату",
  "DeleteRoom": "Видалити кімнату",
  "RoomName": "Назва кімнати",
  "RoomLocation": "Місцезнаходження / поверх",
  "RoomDescription": "Опис",
  "ConfirmDeleteBooking": "Видалити це бронювання?",
  "ConfirmDeleteRoom": "Видалити цю кімнату?",
  "BookingResource": "Ресурс",
  // Reports 
  "SortBy": "Сортувати за",
  "User": "Користувач",
  "StatusReport": "Статус",
  "Export": "Експортувати",
  "AddFilters": "Додати Фільтри",
  // Users 
  "Email": "Електронна пошта",
  "Role": "Роль",
  "users": "користувачі",
  "UsersList": "Список користувачів",
  "AddUser": "Додати користувача",
  "fillter": "фільтр...",
  "EditUser": "Редагувати користувача",
  "PersonalInformation": "Особиста інформація",
  "LastName": "Прізвище",
  "SecondName": "По батькові",
  "DateOfBirth": "Дата народження",
  "Sex": "Стать",
  "WorkInformation": "Робоча інформація",
  "JobTitle": "Посада",
  "ContractStartDate": "Дата початку контракту",
  "Department": "Відділ",
  "ContractType": "Тип контракту",
  "ContractedHoursPerWeek": "Годити на тиждень за контрактом",
  "MinLeaveEntitlement": "Мін. відпустка",
  "ContactInformation": "Контактна інформація",
  "MobilePhone": "Мобільний телефон",
  "WorkPhone": "Робочий телефон",
  "Postcode": "Індекс",
  "City": "Місто",
  "Address": "Адреса",
  "OtherSettings": "Інші налаштування",
  "TimeZone": "Часовий пояс",
  "NotificationLanguage": "Мова сповіщень",
  "ChangePassword": "Змінити пароль",
  "SavedSuccessfully": "Збережено успішно",
  "PhotoUpdated": "Фото оновлено",
  "PhotoTooLarge": "Файл повинен бути менше 5 МБ",
  "PhotoUploadError": "Помилка завантаження",
  "PasswordChanged": "Пароль змінено",
  "PasswordsDoNotMatch": "Паролі не співпадають",
  "EnterPassword": "Введіть пароль",
  "ErrorSaving": "Помилка збереження",
  "RegisterUser": "Зареєструвати користувача",
  "RegistrationInformation": "Інформація про реєстрацію",
  "Password": "Пароль",
  "LastLogin": "Останній Вхід",
  "View": "Відображувати",
  "ConfirmPassword": "Підтвердити пароль",
  "FirstName": "Ім'я",
  "AreYouUser": "Ви впевнені, що хочете видалити цього користувача?",
  // Settings 
  "CompanyInfo": "Інформація про компанію",
  "CompanyName": "Назва компанії",
  "EditPanel": "Панель редагування",
  "Settings": 'Керування',
  "AddCategory": "Додати категорію",
  "AddChildCategoryFor": "Додати дочірню категорію для",
  "SelectSupervisor": "Вибрати керівника",
  "AddTasks": "Додати завдання",
  "AddCont": "Додати контракт",
  "AddDep": "Додати департамент",
  "AddParentCategory": "Додати батьківську категорію",
  "ChangeNameCategory": "Змінити назву категорії",
  "ChangeParents": "Змінити батьків",
  "AreYouSure": "Ви впевнені, що хочете видалити",
  "Sourc": "це джерело",
  "Sour": "джерела",
  "LegalEntityType": "тип юридичної особи",
  "LegalEntity": "юридичної особи",
  "LegalEntityFix": "юридичну особу",
  "Cat": "цю категорію",
  "Cont": "цей контракт",
  "Dep": "цей департамент",
  "DepT": "департамент",
  "Loc": "цю локацію",
  "Stat": "статус",
  "Equ": "цю категорію",
  "Tasks": "це завдання",
  "ChangeName": "Змінити назву",
  "AddRole": "Додати роль",
  "EnterNameOf": "Введіть назву",
  "EditRole": "Редагувати роль",
  "RoleName": "Назва ролі",
  "ColorRole": "Колір ролі",
  "CreateRole": "Створити Роль",
  "RoleAccess": "Доступ до ролі",
  "Delete": "Видалити",
  "ShowAll": "Пок. всі",
  "AddEdit": "Додати/Редагувати",
  "AreYouSureRole": "Ви впевнені, що хочете видалити цю роль?",
  "Create": "Створити",
  "Location": "Локацію",
  "Status": "статусу",
  "CatEqu": "Категорію Обладнання",
  "CatEqupm": "Категорії Обладнання",
  "Contract": "Контракт",
  "TasksType": "Завдання",
  "Roles": "Ролі",
  "Availability": "Доступність",
  "CreateEdit": "Ств/Ред",
  "EnterNameOfRole": "Введіть назву ролі",
  "ChangeColor": "Змінити колір",
  "EditTitle": "Редагувати назву",
  "DeleteRole": "Видалити роль",
  // Finance
  "SalaryPerHours": "З/п за годину",
  "AddNewSalary": "Додати нову зарплату",
  "DateNewSalary": "Дата нової зарплати",
  "StartDate": "Початкова дата",
  "CostPerHour": "Вартість за годину",
  "PerWeek": "За тиждень",
  "History": "Історія",
  "EndDate": "Дата закінчення",
  "RemoveAll": "Видалити все",
  "Information": "Інформація",
  "empty": "пусто",
  // TOIL
  "TotalTOIL": "Загальний TOIL",
  "AddToils": "Додати відпустку за робочий час",
  "AddInformation": "Додати інформацію",
  "CreatingDate": "Дата створення",
  "TotalHours": "Загальна кількість годин",
  "OursPerWeek": "Годин на тиждень",
  "Source": "Джерело",
  "removeTOIL": "Видалити TOIL",
  "discriptions": "Опис",
  "Refresh": "Оновити",
  // Tasks 
  "AllTasks": "Усі завдання",
  "SelectTasksPoins": "Вибрати завдання..",
  // Уdit Reports 
  "EditReports": "Редагувати звіти",
  "EditDate": "Редагувати дату",
  "EditCategory": "Редагувати категорію",
  "SelectTasks": "Вибрати завдання",
  "EditDescription": "Редагувати опис",
  // Delete modal 
  "AreYouReport": "Ви впевнені, що хочете видалити цей звіт?",
  "AreYouReportCat": "Ви впевнені, що хочете видалити категорію",
  "AreYouReportCatModal": "Ви впевнені, що хочете видалити категорію",
  // All button 
  "Yes": "Так",
  "No": "Hi",
  "Cancel": "Скасувати",
  "Change": "Змінити",
  "Register": "Реєстрація",
  "Close": "Закрити",
  // Other 
  "underDevelopment": "У розробці",
  "underDevelopmentSoon": "Очікуємо, що буде готово протягом наступного місяця. Дякуємо за терпіння!",
  "ReturnToHome": "Повернутися На Головну",
  "LoginLog": "Логін",
  "SignIn": "Увійти",
  "SignUp": "Зареєструватися",
  "SelectCountry": "Оберіть країну",
  "CreateAccount": "Створіть акаунт",
  "CreateAccountSub": "Почніть керувати командою в TimeBerlo за лічені хвилини.",
  "AuthHeroTitle": "Розумніший спосіб",
  "AuthHeroAccent": "керувати командою",
  "AuthHeroSub": "Табелі, погодження, витрати, HR-документи та CRM — усе в одному місці.",
  "TrustSsl": "256-бітний SSL",
  "TrustGdpr": "Відповідає GDPR",
  "AllFieldsRequired": "Усі поля обов'язкові",
  "InvalidEmailFormat": "Невірний формат email",
  "RegistrationFailed": "Не вдалося зареєструватися. Спробуйте ще раз.",
  "RegistrationSuccess": "Реєстрація успішна",
  "VerifyEmailTitle": "Перевірте пошту",
  "VerifyEmailSentTo": "Ми надіслали посилання для підтвердження на",
  "VerifyEmailDesc": "Натисніть посилання, щоб активувати акаунт і почати роботу з TimeBerlo.",
  "VerifyEmailSpam": "Не отримали? Перевірте папку «Спам».",
  "GoToLogin": "Перейти до входу",
  "EmailAlreadyRegistered": "Акаунт з таким email вже існує",
  "PasswordRequirements": "Пароль має містити щонайменше 8 символів, великі й малі літери та спеціальний символ",
  "OrContinueWith": "або продовжити з",
  "ComingSoon": "Незабаром",
  "NeedAnAccount": "Потрібен акаунт",
  "ForgotPassword": "Забули пароль",
  "AlreadyRegistered": "Вже зареєстровані",
  "PleasePutYourEmail": "Введіть вашу електронну пошту",
  "Send": "Відправити",
  "SendReminder": "Надіслати нагадування",
  "Company": "Компания",
  "січень": "Січень",
  "лютий": "Лютий",
  "березень": "Березень",
  "квітень": "Квітень",
  "травень": "Травень",
  "червень": "Червень",
  "липень": "Липень",
  "серпень": "Серпень",
  "вересень": "Вересень",
  "жовтень": "Жовтень",
  "листопад": "Листопад",
  "грудень": "Грудень",
  "Monday": "Понеділок",
  "Tuesday": "Вівторок",
  "Wednesday": "Середа",
  "Thursday": "Четвер",
  "Friday": "П'ятниця",
  "Saturday": "Субота",
  "Sunday": "Неділя",
  // CRM & Community
  "CRM": "CRM",
  // Tasks
  "TasksNav": "Завдання",
  "Add task": "Додати завдання",
  "Search tasks": "Пошук завдань",
  "Assigned": "Виконавці",
  "Priority": "Пріоритет",
  "More options": "Більше опцій",
  "Add people": "Додати людей",
  "Add card": "Додати картку",
  "Drag to reorder": "Перетягніть, щоб змінити порядок",
  "Drop tasks here": "Перетягніть картки сюди",
  "Mark as done": "Позначити виконаним",
  "Mark as not done": "Зняти позначку виконання",
  "Untitled": "Без назви",
  "Task title…": "Назва завдання…",
  "Description…": "Опис…",
  "All": "Всі",
  "None": "Немає",
  "Columns": "Колонки",
  "Created": "Створено",
  "Repeat": "Повтор",
  "Who can see it": "Хто це бачить",
  "Repeats on": "Повторювати з",
  "Everyone": "Усі",
  "My team": "Моя команда",
  "Assignees only": "Лише виконавці",
  "Only me": "Лише я",
  "Daily": "Щодня",
  "Weekly": "Щотижня",
  "Monthly": "Щомісяця",
  "On a date…": "У дату…",
  "Created by me": "Створені мною",
  "Assigned to me": "Призначені мені",
  "Visible to all": "Видимі всім",
  "Board settings": "Налаштування дошки",
  "New column name…": "Назва нової колонки…",
  "DeleteColumnConfirm": "Видалити цю колонку? Її картки перемістяться в сусідню колонку.",
  "Delete this card?": "Видалити цю картку?",
  "Available": "Доступні",
  "Change color": "Змінити колір",
  "Community": "Ком'юніті",
  "Contacts": "Контакти",
  "Organisations": "Організації",
  "Projects": "Проекти",
  "ContactType": "Тип контакту",
  "OrganisationType": "Тип організації",
  "AddContact": "Додати контакт",
  "ContactsList": "Список контактів",
  "AddOrganisation": "Додати організацію",
  "AddProject": "Додати проект",
  "MiddleName": "По батькові",
  "Gender": "Стать",
  "Ethnicity": "Етнічна приналежність",
  "Archive": "Архівувати",
  "Pseudonymise": "Псевдонімізувати",
  "PseudonymisationQueue": "Черга псевдонімізації",
  "ProjectPurpose": "Призначення проекту",
  "Commercial": "Комерційний",
  "Internal": "Внутрішній",
  "Grant": "Грант",
  "Programmes": "Програми",
  "Sessions": "Сесії",
  "Participants": "Учасники",
  "Monitor": "Моніторинг",
  "Surveys": "Опитування",
  "Overview": "Огляд",
  "FieldSettings": "Налаштування полів",
  "AddField": "Додати поле",
  "Required": "Обов'язкове",
  "Hidden": "Приховане",
  "FieldType": "Тип поля",
  "Section": "Розділ",
  "AddressLine1": "Адреса (рядок 1)",
  "AddressLine2": "Адреса (рядок 2)",
  "Country": "Країна",
  "FindAddress": "Знайти адресу",
  "SelectAddress": "Оберіть адресу",
  "CharityNumber": "Реєстраційний номер благодійної організації",
  "CompanyRegNumber": "Реєстраційний номер компанії",
  "VatNumber": "Номер платника ПДВ",
  "EoriNumber": "Номер EORI",
  "EmployeesNumber": "Кількість співробітників",
  "ContractValue": "Вартість контракту",
  "ContractRef": "Номер контракту",
  "IsActive": "Активний",
  "IsPseudonymised": "Псевдонімізований",
  "SortOrder": "Порядок сортування",
  "Slug": "Слаг",
  "Icon": "Іконка",
  "ColorType": "Колір",
  "FieldConfig": "Конфігурація полів",
  "Group": "Група",
  "ProjectType": "Тип проекту",
  "Fields": "Поля",
  "ContactFields": "Поля контакту",
  "SystemFields": "Системні поля",
  "CustomFields": "Поля",
  "ProfileFields": "Поля профілю",
  "ProfileWeight": "Вага",
  "AdditionalFields": "Додаткові поля",
  "ProfileCompletion": "Заповненість профілю",
  "HrUserProfile": "Профіль користувача",
  "Field": "Поле",
  "Values": "Значення",
  "Visible": "Видиме",
  // Gender options (by name key)
  "gender_Male": "Чоловік",
  "gender_Female": "Жінка",
  "gender_NonBinary": "Небінарна особа",
  "gender_Transgender": "Трансгендер",
  "gender_Other": "Інше",
  "gender_PreferNotToSay": "Не хочу вказувати",
  // Ethnicity options (by ID — 20 UK census entries)
  "ethnicity_1": "Англієць, валлієць, шотландець, північний ірландець або британець",
  "ethnicity_2": "Ірландець",
  "ethnicity_3": "Циган або ірландський мандрівник",
  "ethnicity_4": "Рома",
  "ethnicity_5": "Інше білошкіре походження",
  "ethnicity_6": "Білий і чорний карибець",
  "ethnicity_7": "Білий і чорний африканець",
  "ethnicity_8": "Білий та азіат",
  "ethnicity_9": "Інше змішане або багаторасове походження",
  "ethnicity_10": "Індієць",
  "ethnicity_11": "Пакистанець",
  "ethnicity_12": "Бангладешець",
  "ethnicity_13": "Китаєць",
  "ethnicity_14": "Інше азіатське походження",
  "ethnicity_15": "Африканець",
  "ethnicity_16": "Карибець",
  "ethnicity_17": "Інше чорне, чорношкіре британське або карибське походження",
  "ethnicity_18": "Арабець",
  "ethnicity_19": "Інша етнічна група",
  "ethnicity_20": "Не вказано",
  "EditFields": "Редагувати поля",
  "SelectField": "Оберіть поле",
  "Apply": "Застосувати",
  "Value": "Значення",
  // Training
  "Training": "Навчання",
  "TrainingMyCourses": "Моє навчання",
  "TrainingAddCourse": "Додати курс",
  "TrainingEditCourse": "Редагувати курс",
  "TrainingAddPage": "Додати сторінку",
  "TrainingEditPage": "Редагувати сторінку",
  "TrainingAddQuestion": "Додати питання",
  "TrainingEditQuestion": "Редагувати питання",
  "TrainingMyLearning": "Курси",
  "TrainingLibrary": "Бібліотека",
  "TrainingResults": "Результати",
  "TrainingManage": "Керування",
  "TrainingCreateCourse": "Створити курс",
  "TrainingStart": "Почати",
  "TrainingRetake": "Пройти знову",
  "TrainingReview": "Переглянути",
  "TrainingStartQuiz": "Пройти тест",
  "TrainingSubmit": "Відправити тест",
  "TrainingQuiz": "Тест",
  "TrainingPages": "сторінок",
  "TrainingRead": "прочитано",
  "TrainingQuestions": "питань",
  "TrainingNotStarted": "Не розпочато",
  "TrainingPassed": "Пройдено",
  "TrainingFailed": "Не пройдено",
  "TrainingCorrect": "Правильно",
  "TrainingErrors": "Помилок",
  "TrainingPassThreshold": "Мінімальний бал",
  "TrainingForAll": "Призначити всім співробітникам",
  "TrainingPageImage": "Зображення / вкладення",
  "TrainingUploadImage": "Завантажити зображення",
  "TrainingImageTooBig": "Зображення має бути менше 5МБ",
  "TrainingEnterTitle": "Будь ласка, введіть назву",
  "TrainingEnterQuestion": "Будь ласка, введіть текст питання",
  "TrainingMinAnswers": "Заповніть мінімум 2 відповіді",
  "TrainingMarkCorrect": "Позначте хоча б одну правильну відповідь",
  "TrainingMarkCorrectHint": "Поставте галочку біля правильної відповіді",
  "TrainingRetakeMessage": "Результат нижче {threshold}%. Рекомендуємо пройти курс повторно.",
  "TrainingAnswers": "Варіанти відповідей",
  "TrainingAnswer": "Відповідь",
  "TrainingQuestionText": "Питання",
  "TrainingSaveSuccess": "Збережено успішно",
  "TrainingErrorOccurred": "Виникла помилка",
  "TrainingQuestionType": "Тип питання",
  "TrainingMarkAllCorrect": "Відмітьте всі правильні відповіді",
  "TrainingSelectUsers": "Призначити користувачам",
  "TrainingRetakeInterval": "Повтор кожні N днів",
  "TrainingMultipleChoice": "Кілька правильних",
  "TrainingTrueFalse": "Так / Ні",
  "TrainingSingleChoice": "Одна правильна",
  "TrainingYesNo": "Так / Ні",
  "TrainingSelectAll": "Оберіть усі правильні",
  "TrainingAnswered": "Відповідей",
  "TrainingPagesRead": "Сторінок прочитано",
  "TrainingQuizScore": "Результат тесту",
  "TrainingProgress": "Прогрес",
  "TrainingContent": "Зміст",
  "TrainingKnowledgeCheck": "Перевірка знань",
  "TrainingModule": "Модуль",
  "TrainingInProgress": "В процесі",
  "TrainingCompleted": "Завершено",
  "TrainingCoursesCount": "курсів",
  "TrainingTeamProgress": "Прогрес команди",
  "TrainingCourseSettings": "Налаштування курсу",
  "TrainingAssignedTo": "Призначено",
  "TrainingUsersNotStarted": "Не почали",
  "TrainingRemindAll": "Нагадати незавершеним",
  "TrainingRemindSent": "Нагадування відправлено",
  "TrainingResetResults": "Скинути проходження",
  "TrainingResetConfirm": "Скинути всі результати цього курсу? Користувачам потрібно буде пройти його знову.",
  "TrainingDeleteCourse": "Видалити курс",
  "TrainingDeleteConfirm": "Видалити цей курс? Цю дію неможливо скасувати.",
  "TrainingNotCompleted": "Не завершено",
  "TrainingAllUsers": "Всі",
  "TrainingReports": "Звіти",
  "TrainingCongrats": "Вітаємо!",
  "TrainingRemaining": "Залишилось",
  "TrainingHtmlView": "HTML",
  "TrainingVisualView": "Візуальний",
  "TrainingInsertVideoUrl": "Вставте URL відео (YouTube, Vimeo…)",
  "TrainingPublishDate": "Дата публікації",
  "TrainingScheduled": "Заплановано",
  "TrainingByDepartment": "За департаментом",
  "TrainingNotifyUsers": "Повідомити",
  "TrainingNotifySent": "Повідомлення надіслані",
  "TrainingRemindUsers": "Нагадати",
  "TrainingReminderSent": "Нагадування надіслані",
  "HidePanel": "Сховати панель",
  "Disk": "Диск",
  "DiskUpload": "Завантажити",
  "DiskAllFiles": "Всі файли",
  "DiskImages": "Зображення",
  "DiskDocuments": "Документи",
  "DiskVideos": "Відео",
  "DiskDeleteFile": "Видалити файл",
  "DiskPickFile": "Обрати файл",
  "DiskFiles": "Файли",
  "DiskStorage": "Сховище",
  "DiskTotalUsed": "Зайнято",
  "DiskFolders": "Папки",
  "DiskFree": "вільно",
  "Content": "Зміст",
  "Save": "Зберегти",
  "Payroll": "Зарплата",
  "Income": "Дохід",
  "Balance": "Баланс",
  "Incoming": "Вхідні",
  "Outgoing": "Вихідні",
  "Transactions": "Транзакції",
  "AddIncome": "Додати дохід",
  "FillRequired": "Заповніть обов'язкові поля",
  "InviteUser": "Запросити користувача",
  "InviteSent": "Запрошення надіслано",
  "InviteCreatedNoMail": "Користувача створено, але лист-запрошення не надіслано — перевірте SMTP-налаштування компанії.",
  "InviteHint": "На email буде надіслано запрошення з посиланням на портал. Людина встановить пароль, а після першого входу заповнить свій профіль.",
  "SendInvite": "Надіслати запрошення",
  "InvalidEmail": "Некоректний email",
  "DefaultRoleForNew": "Роль за замовчуванням для нових співробітників",
  "MakeDefaultForNew": "Зробити роллю за замовчуванням для нових користувачів",
  "SystemRole": "Системна",
  "SystemRoleHint": "Системна роль — видалити не можна",
  "HrRoundingDay": "Округлення (дні)",
  "HrRoundingHour": "Округлення (години)",
  "HrRule_up_day": "Вгору до цілого дня",
  "HrRule_up_half_day": "Вгору до пів дня",
  "HrRule_nearest_half_day": "До найближчого пів дня",
  "HrRule_up_hour": "Вгору до цілої години",
  "HrRule_up_half_hour": "Вгору до пів години",
  "HrRule_nearest_half_hour": "До найближчих пів години",
  "HrRule_none": "Без округлення",
  "HrUseRounding": "Округлювати норму відпустки",
  "HrUnitDay": "день",
  "HrUnitHour": "година",
  "HrRuleWordUp": "вгору до",
  "HrRuleWordNearest": "до найближчого",
  "HrRuleWordDown": "вниз до",
  "HrRuleWordUpFrom": "вгору від",
  "HrStepWholeWord": "цілого",
  "HrRoundingDescPrefix": "Норма округлюється",
  "HrFromSettings": "правило з налаштувань HR",
  "HrRoundingNoneCfg": "Правило округлення не задано в налаштуваннях HR — значення залишається точним.",
  "HrRoundingOffDesc": "Норма показується точно, без округлення.",
  "HrRoundedLabel": "Округлено",
  "HrNoRounding": "Без округлення",
  "HrRoundingIntro": "Як округлюється річна норма. Поріг = частка кроку, з якої округляємо вгору (0 = завжди вгору, 0.5 = стандартно, 1 = завжди вниз).",
  "HrStepWhole": "Ціле",
  "HrStepHalf": "0.5",
  "HrStepQuarter": "0.25",
  "HrStepTenth": "0.1",
  "HrRuleAlwaysUp": "Завжди вгору (≥0)",
  "HrRuleUp25": "Вгору від 0.25",
  "HrRuleUp30": "Вгору від 0.3",
  "HrRuleStandard": "Стандартно (≥0.5)",
  "HrRuleAlwaysDown": "Завжди вниз (≥1)",
  "HrRuleCustom": "Своє…",
  "HrRoundUpFrom": "Округляти вгору від",
  "HrErrAfterNext": "Дата має бути раніше наступної зміни патерну.",
  "HrContractAfterSegment": "Початок контракту має бути раніше наступної зміни патерну ({date}). Спочатку перенесіть або видаліть цю зміну.",
  "HrAutoCorr": "авто",
  "HrErrBeforePrev": "Дата має бути пізніше попередньої зміни патерну.",
  "HrRoundingOff": "без округлення",
  "FillProfileTitle": "Заповніть свій профіль",
  "FillProfileHint": "Ласкаво просимо! Приділіть хвилину, щоб заповнити свої дані.",
  "RemindNextLogin": "Нагадати при наступному вході",
  "SaveAndClose": "Зберегти",
  "EmergencyContact": "Контакт для екстрених випадків",
  "SetPassword": "Встановити пароль",
  "OrgTree": "Організаційне дерево",
  "OrgChart": "Орг. схема",
  "OrgChartEmployees": "Співробітники",
  "OrgChartDepartments": "Відділи",
  "OrgChartManagers": "Керівники",
  "OrgChartLevels": "Рівнів",
  "ExpandAll": "Розгорнути",
  "CollapseAll": "Згорнути",
  "AllDepartments": "Всі відділи",
  "NoDepartment": "Без відділу",
  "EditMode": "Ред. режим",
  "AddUserToDept": "Додати",
  "AddNewUser": "Новий",
  "AddExistingUser": "Існуючий",
  "AddSubDept": "Підрозділ",
  "MoveHere": "Перенести сюди",
  "AddHere": "Додати (дублікат)",
  "OrgManagers": "Керівники",
  "OrgEmployees": "Співробітники",
  "DeptHasUsers": "Неможливо видалити: є співробітники",
  "OrgSearch": "Пошук за іменем або посадою...",
  "OrgAllDepts": "Всі відділи",
  "OrgSortAZ": "Ім'я А → Я",
  "OrgSortZA": "Ім'я Я → А",
  "OrgStatusActive": "Активні",
  "OrgStatusInactive": "Неактивні",
  "Deactivate": "Деактивувати",
  "Reactivate": "Активувати",
  "ActiveUsers": "Активні користувачі",
  "InactiveUsers": "Неактивні користувачі",
  "OrgStatusAll": "Всі",
  "OrgTreeView": "Дерево",
  "OrgCardsView": "Картки",
  "OrgListView": "Список",
  "Inactive": "Неактивні",
  "OrgTabCalendar": "Календар",
  // History / Logs
  "Logs": "Логи",
  "LogService": "Сервіс",
  "LogSuccess": "Успіх",
  "LogError": "Помилка",
  "AddTemplate": "Додати шаблон",
  "maximum20characters": "максимум 20 символів",
  "HoursPerWeek": "Годин на тиждень",
  // Role permissions — module hints
  "RoleHint_finance": "Доступ до Фінансів: витрати, доходи, зарплати, витрати на авто.",
  "RoleHint_timesheets": "Таймшити — облік відпрацьованих годин по днях.",
  "RoleHint_toil": "Відгул (TOIL) — баланс понаднормових годин відносно контракту.",
  "RoleHint_equipment": "Реєстр обладнання — пристрої, інструменти, активи компанії.",
  "RoleHint_hr": "HR-розділ: каталог співробітників, оргструктура, відділи.",
  "RoleHint_booking": "Бронювання кімнат і ресурсів для переговорів.",
  "RoleHint_docs": "Сховище документів: правила, договори, шаблони.",
  "RoleHint_crm": "CRM — контакти, організації та проекти.",
  "RoleHint_community": "Спільнота: програми, сесії, учасники.",
  "RoleHint_training": "Електронне навчання: курси, тести, записи навчання.",
  "RoleHint_disk": "Файлове сховище — завантаження, організація, обмін файлами.",
  "RoleHint_reports": "Звіти: таймшити, відсутності, зарплати, аналітика.",
  "RoleHint_orders": "Замовлення клієнтів, запити на послуги, відстеження проектів.",
  "RoleHint_settings": "Налаштування компанії: часовий пояс, валюта, пошта, графік.",
  // Role permissions — tab hints
  "RoleHint_finance_expenses": "Свої — власні витрати. Відділ — відділу. Всі — всі витрати компанії.",
  "RoleHint_finance_income": "Свої — власні доходи. Відділ — відділу. Всі — всі доходи компанії.",
  "RoleHint_finance_payroll": "Свої — власні зарплатні листи. Всі — управління всіма зарплатами.",
  "RoleHint_finance_car_expenses": "Свої — власні витрати на авто. Відділ — відділу. Всі — всі.",
  "RoleHint_timesheets_access": "Свої — власний таймшит. Відділ — таймшити відділу. Всі — всі.",
  "RoleHint_toil_access": "Свої — власний баланс. Відділ — команда. Всі — всі співробітники.",
  "RoleHint_equipment_access": "Свої — призначене цьому користувачу. Відділ — відділ. Всі — все.",
  "RoleHint_hr_access": "Свої — власний профіль. Відділ — члени відділу. Всі — всі.",
  "RoleHint_booking_access": "Свої — власні бронювання. Відділ — відділу. Всі — всі бронювання.",
  "RoleHint_docs_access": "Свої — особисті документи. Відділ — папка відділу. Всі — всі.",
  "RoleHint_community_access": "Свої — власні сесії. Відділ — програми відділу. Всі — всі дані.",
  "RoleHint_disk_access": "Свої — власні файли. Відділ — спільні файли відділу. Всі — всі.",
  "RoleHint_reports_access": "Свої — власні дані. Відділ — звіти відділу. Всі — по всій компанії.",
  "RoleHint_orders_access": "Свої — призначені замовлення. Відділ — відділу. Всі — всі замовлення.",
  // Role permissions — bool hints
  "RoleHint_finance_approve": "Може схвалювати або відхиляти витрати інших співробітників.",
  "RoleHint_finance_admin": "Повний доступ: налаштування, категорії, всі фінансові записи.",
  "RoleHint_timesheets_approve": "Може схвалювати або відхиляти тижневі таймшити.",
  "RoleHint_timesheets_admin": "Налаштування, категорії, шаблони. Може редагувати будь-який запис.",
  "RoleHint_toil_manage": "Може вручну коригувати баланс TOIL для будь-якого користувача.",
  "RoleHint_hr_manage": "Може створювати облікові записи та редагувати дані співробітників.",
  "RoleHint_hr_admin": "Повний адмін: видалення, призначення ролей, управління відділами.",
  "RoleHint_booking_admin": "Може створювати, редагувати та видаляти кімнати і ресурси.",
  "RoleHint_docs_admin": "Може завантажувати документи, створювати папки, керувати квитанціями.",
  "RoleHint_training_view": "Може переглядати та проходити призначені навчальні курси.",
  "RoleHint_training_admin": "Може створювати, редагувати та видаляти курси і питання.",
  "RoleHint_disk_admin": "Може видаляти будь-які файли, включно з файлами інших користувачів.",
  "RoleHint_reports_export": "Може завантажувати звіти у форматі CSV/Excel.",
  "RoleHint_orders_manage": "Може створювати замовлення, оновлювати статус, призначати виконавців.",
  "RoleHint_settings_admin": "Може змінювати загальні налаштування компанії, пошту та портал.",
  "WorkingStatus": "Робочий статус",
  "WorkingStatuses": "Робочі статуси",
  "AddWorkingStatus": "Додати статус",
  "WorkingStatusName": "Назва статусу",
  "WorkingStatusColor": "Колір",
  "WorkingStatusEmoji": "Іконка",
  "WorkingStatusSaved": "Статус оновлено",
  "WorkingStatusClearLabel": "Очистити статус",
  "WorkingStatusSetup": "Налаштуйте робочі статуси команди. Системні статуси не можна видалити.",
  "SelectExisting": "Обрати існуючого",
  "HrLeave": "Відпустка",
  "HrSickness": "Лікарняні",
  "HrLateness": "Запізнення",
  "HrSettings": "Налаштування HR",
  "HrScheduleTemplates": "Шаблони розкладу",
  "HrLeaveTypes": "Типи відпустки",
  "HrPublicHolidays": "Державні свята",
  "HrHolidays": "Свята",
  "HrStatuses": "Статуси",
  "AbsenceLeave": "Відпустки та свята",
  "Localization": "Локалізація",
  "Billing": "Оплата",
  "Tools": "Інструменти",
  "CompanyVehicles": "Корпоративні авто",
  "ExpenseFields": "Поля витрат",
  "HrAllowance": "Норма",
  "HrAllowanceUnit": "Одиниця",
  "HrPartialDay": "Неповний день",
  "HrRequiresApproval": "Схвалення",
  "HrTemplateName": "Назва шаблону",
  "HrSetAsDefault": "Встановити за замовчуванням",
  "HrScheduleTemplatesHint": "Шаблони визначають робочий час. Призначаються кожному співробітнику.",
  "HrAbsences": "Відсутності",
  "HrAbsenceAll": "Всі",
  "HrAbsenceType": "Тип відсутності",
  "HrAddAbsence": "Додати відсутність",
  "HrEditAbsence": "Редагувати відсутність",
  "HrChangeSupervisor": "Змінити супервайзера",
  "HrResetSupervisor": "Скинути до супервайзера за замовчуванням",
  "HrEmployee": "Співробітник",
  "HrAddLeave": "Додати відпустку",
  "HrAddSickness": "Додати лікарняний",
  "HrAddLateness": "Додати запізнення",
  "HrReason": "Причина",
  "HrCertified": "Є довідка",
  "HrMinutesLate": "Хвилин запізнення",
  "From": "Від",
  "Today": "Сьогодні",
  "Error": "Помилка",
  "Min": "хв",
  "HShort": "г",
  "DShort": "д",
  "HrOverview": "Огляд",
  "HrCalendar": "Календар",
  "HrThisMonth": "Цей місяць",
  "HrOut": "відсутні",
  "HrViewMonth": "Вид: місяць",
  "HrViewTimeline": "Вид: таймлайн",
  "HrToApprove": "На затвердження",
  "HrMyAbsences": "Мої відсутності",
  "HrOutToday": "Відсутні сьогодні",
  "HrPendingApproval": "Очікують затвердження",
  "HrUpcomingBirthdays": "Дні народження (2 тиж)",
  "HrExpiringDocs": "Документи закінчуються",
  "HrUpcomingEvents": "Найближчі події",
  "HrBirthday": "День народження",
  "HrLicenseExpiry": "Закінчення ліцензії",
  "HrProbationEnd": "Кінець випробування",
  "HrUsed": "Використано",
  "HrRemaining": "Залишок",
  "HrApprove": "Затвердити",
  "HrReject": "Відхилити",
  "HrSubmit": "Подати",
  "HrCancel": "Відкликати",
  "HrApproved": "Затверджено",
  "HrRejected": "Відхилено",
  "HrSubmitted": "Заявку подано",
  "HrCancelled": "Відкликано",
  "HrRejectReason": "Причина відхилення",
  "HrDuration": "Тривалість",
  "HrDurFull": "Цілий день",
  "HrDurHalfAm": "Півдня (ранок)",
  "HrDurHalfPm": "Півдня (день)",
  "HrDurCustom": "Вказати години",
  "HrDurFullOnly": "Цілий день (вибір тривалості вимкнено в налаштуваннях)",
  "HrSickNote": "Лікарняний / документ",
  "HrRequests": "Відсутність",
  "Male": "Чоловік",
  "Female": "Жінка",
  "Others": "Інше",
  "HrTabPersonal": "Особисті",
  "HrTabEmployment": "Працевлаштування",
  "HrTabOvertime": "Понаднормові",
  "HrTabEmergencies": "Екстрені контакти",
  "HrTabSensitive": "Конфіденційні",
  "HrTabCustom": "Кастомні",
  "HrProbationStart": "Початок випробування",
  "HrNoticePeriod": "Термін попередження",
  "HrDayOff": "Вихідний",
  "HrBreak": "перерва",
  "HrSource": "Джерело",
  "HrEcName": "Ім'я контакту",
  "HrEcRelationship": "Ким приходиться",
  "HrEcPhone": "Телефон",
  "HrEcEmail": "Email",
  "HrSensitiveStub": "Заглушка — поля вимкнено. Збереження, шифрування та доступ додамо пізніше.",
  "HrSensNINO": "Номер соц. страхування",
  "HrSensTaxCode": "Податковий код",
  "HrSensPassport": "Номер паспорта",
  "HrSensBankName": "Банк",
  "HrSensAccountHolder": "Власник рахунку",
  "HrSensAccountNumber": "Номер рахунку",
  "HrSensSortCode": "Sort code",
  "HrSensIBAN": "IBAN",
  "Rel_spouse": "Чоловік/дружина",
  "Rel_partner": "Партнер",
  "Rel_relative": "Родич",
  "Rel_parent": "Батько/мати",
  "Rel_child": "Дитина",
  "Rel_sibling": "Брат/сестра",
  "Rel_friend": "Друг",
  "Rel_other": "Інше",
  "HrDelete": "Видалити",
  "HrConfirmDelete": "Видалити цей патерн?",
  "HrDuplicate": "Дублювати",
  "HrWorking": "Робочий",
  "HrUsersUsing": "використовують цей патерн",
  "HrUseToil": "Враховувати переробки (TOIL)",
  "HrUseToilDesc": "Якщо вимкнено — TOIL авто-компенсується до нуля при відправці табеля (переробки не накопичуються).",
  "HrLeaveUnit": "Облік відпустки в",
  "HrUnitDays": "Днях",
  "HrUnitHours": "Годинах",
  "HrPhIntro": "Виберіть, чи працюють співробітники на цьому патерні у святкові дні та чи входять вони до річної норми відпустки.",
  "HrPhDeducted": "Вираховується",
  "HrPhDeductedDesc": "Отримають вихідний у святкові дні, які зазвичай робочі — за рахунок річної норми відпустки.",
  "HrPhNotDeducted": "Не вираховується",
  "HrPhNotDeductedDesc": "Отримають вихідний у святкові дні, які зазвичай робочі — понад річну норму відпустки.",
  "HrPhWorks": "Працює у свята",
  "HrPhWorksDesc": "Святкові дні вважаються звичайними — вихідного не буде.",
  "HrContractTypes": "Типи контрактів",
  "PatternHistory": "Історія паттернів",
  "ChangePattern": "Змінити паттерн",
  "HrSegmentFrom": "Діє з",
  "HrNoContractDate": "Дата поступлення не вказана — перший сегмент рахується від дати створення акаунта. Заповніть, будь ласка.",
  "HrAddSegment": "Додати зміну паттерна",
  "HrOngoing": "триває",
  "HrRecalculate": "Перерахувати",
  "HrCurrentPattern": "Поточний паттерн",
  "HrBaseByPatterns": "База за паттернами",
  "HrPatternsWord": "паттернів",
  "HrWeightedPerWeek": "Зважені год/тиждень",
  "HrWeeksWord": "тижнів",
  "HrPatternFromContract": "Діє від дати контракту · редагуйте паттерни нижче",
  "HrPatternSaved": "Паттерн додано",
  "HrScheduledChange": "Заплановано",
  "HrDateFromContract": "Дата береться від старту контракту (не редагується)",
  "HrAutoApplyHint": "Застосується автоматично {date} о 00:00 ({tz})",
  "HrAddHint": "Після збереження запуститься перевірка. Якщо TOIL/відпустки зміняться — попросимо підтвердити.",
  "LocalTime": "місцевий час",
  "HrRecalcNeeded": "Потрібен перерахунок після зміни паттерна",
  "HrRecalcWarnBody": "Паттерн збережено. Перевірка знайшла розбіжності в TOIL та відпустках. Перегляньте та натисніть Apply, або Skip щоб залишити як є.",
  "HrRecalcLogged": "Застосування створює запис в аудит-логу",
  "Skip": "Пропустити",
  "AllLogs": "Усі логи",
  "RecalcLogTab": "Перерахунок TOIL та відпусток",
  "LogTrigger": "Тригер",
  "ChangedBy": "Хто змінив",
  "HrRecalcPreview": "Попередній перегляд перерахунку",
  "HrRecalcNoChanges": "Змін немає — усе актуально.",
  "HrApplyChanges": "Застосувати зміни",
  "Was": "Було",
  "Now": "Стало",
  "NetToilFiltered": "Чистий TOIL (фільтр)",
  "Entries": "Записів",
  "DateOrSource": "дата або джерело...",
  "Clear": "Очистити",
  "Week": "Тиждень",
  "Logged": "Відпрацьовано",
  "Report": "Звіт",
  "Manual": "Вручну",
  "Comment": "Коментар",
  "Current": "Поточний",
  "Initial": "Початковий",
  "Loading": "Завантаження…",
  "HrResetPassword": "Скинути пароль",
  "HrDisableAccount": "Вимкнути акаунт",
  "Activate": "Активувати",
  "HrActiveOnly": "Лише активні",
  "HrNewPassword": "Новий пароль",
  "HrSchedule": "Графік",
  "Start": "Початок",
  "End": "Кінець",
  "EffectiveFrom": "Дата вступу в силу",
  "PreviousPattern": "Попередній паттерн",
  "ReasonForUpdate": "Причина зміни",
  "ActionedDate": "Дата дії",
  "NoPatternHistory": "Змін паттерну ще не зафіксовано.",
  "HrWorkingPattern": "Робочий патерн",
  "HrWorkingPatterns": "Робочі патерни",
  "HrAddPattern": "Додати патерн",
  "HrPatternName": "Назва патерну",
  "HrWorksHolidays": "Працює у свята",
  "HrPerWeek": "на тиждень",
  "HrExclBreaks": "без перерв",
  "Default": "За замовчуванням",
  "Saved": "Збережено",
  "HrGeneral": "Загальні",
  "HrAbsenceSettings": "Налаштування відсутностей",
  "HrAllowPartialDay": "Дозволити вибір тривалості (півдня, години)",
  "HrAllowPartialDayHint": "Якщо вимкнено — усі відсутності подаються як цілий день без вибору (за замовчуванням).",
  "HrStatus_draft": "Чернетка",
  "HrStatus_pending": "Очікує",
  "HrStatus_approved": "Затверджено",
  "HrStatus_rejected": "Відхилено",
  "HrStatus_cancelled": "Скасовано",
  "HrStatus_recorded": "Зафіксовано",
  "HrStatusApproved": "Затверджено",
  "HrStatusPending": "Очікує",
  "HrStatusRecorded": "Зафіксовано",
  "WD_Mon": "Пн",
  "WD_Tue": "Вт",
  "WD_Wed": "Ср",
  "WD_Thu": "Чт",
  "WD_Fri": "Пт",
  "WD_Sat": "Сб",
  "WD_Sun": "Нд",
  "ReturnDate": "Дата повернення",
  "ContractTypeUseTOIL": "Використовувати TOIL",
  "ToilAutoCorrection": "Авто-корекція",
  "err_save_generic": "Не вдалося зберегти зміни. Спробуйте ще раз.",
  "err_email_in_use": "Ця електронна адреса вже використовується іншим співробітником.",
  "err_invalid_enum": "Некоректне значення в одному з полів (наприклад, Стать або Статус).",
  "err_invalid_date": "Некоректна дата в одному з полів дати.",
  "err_invalid_number": "Некоректне число в одному з числових полів.",
  "err_fk_not_found": "Пов'язаний запис не знайдено — відділ, тип контракту або роль могли бути видалені.",
  "Dashboard": "Дашборд",
  "Finance": "Фінанси",
  "HR": "HR · Персонал",
  "Docs": "Документи",
  "news_announcements": "Оголошення компанії",
  "news_add": "Додати оголошення",
  "news_edit": "Редагувати",
  "news_delete": "Видалити",
  "news_pin": "Закріпити",
  "news_unpin": "Відкріпити",
  "news_pinned": "Закріплено",
  "news_publish": "Опублікувати",
  "news_save": "Зберегти зміни",
  "news_all": "Всі новини",
  "news_title_label": "Заголовок",
  "news_body_label": "Повідомлення",
  "news_title_placeholder": "напр. Закриття офісу — 23 червня",
  "news_body_placeholder": "Напишіть оголошення тут…",
  "news_emoji_label": "Іконка (емодзі)",
  "news_color_label": "Колір фону іконки",
  "news_pin_label": "Закріпити це оголошення",
  "news_pin_hint": "Закріплені пости завжди відображаються першими та виділяються значком",
  "news_preview_label": "Попередній перегляд",
  "RoleHint_dashboard_settings": "Доступ до налаштувань дашборду та керування оголошеннями (закріплення, видалення будь-яких).",
  "RoleHint_dashboard_widget_feed_enabled": "Віджет стрічки новин доступний для додавання на дашборд.",
  "RoleHint_dashboard_edit_own": "Може переставляти, додавати й прибирати блоки на власному дашборді.",

  "AddedBy": "Додав",
  "DirectLink": "Пряме посилання",

  // ImageUpload universal component
  "ImgUpTitle": "Вставити зображення",
  "ImgUpTitleSub": "Завантаження, обрізка та оптимізація",
  "ImgUpFile": "Файл",
  "ImgUpCamera": "Камера",
  "ImgUpDrop": "Перетягніть зображення сюди",
  "ImgUpDropSub": "або натисніть для вибору · до 20 МБ",
  "ImgUpChooseFile": "Вибрати файл",
  "ImgUpEditorTitle": "Редактор зображення",
  "ImgUpMode": "Режим",
  "ImgUpModeOptimize": "Оптимізувати",
  "ImgUpModeCrop": "Обрізати",
  "ImgUpModeOriginal": "Оригінал",
  "ImgUpModeOptimizeHint": "Режим оптимізації · без обрізання",
  "ImgUpModeOriginalHint": "Файл завантажується без змін",
  "ImgUpRatio": "Пропорції",
  "ImgUpFree": "Вільно",
  "ImgUpZoom": "Масштаб",
  "ImgUpRotation": "Поворот",
  "ImgUpQuality": "Якість",
  "ImgUpMaxWidth": "Макс. ширина",
  "ImgUpOriginalSize": "оригінал",
  "ImgUpAfterSize": "Результат",
  "ImgUpFilename": "Ім'я файлу",
  "ImgUpInsert": "Вставити ↵",
  "ImgUpBack": "← Назад",
  "ImgUpSnap": "Зробити знімок",
  "ImgUpRetake": "↩ Перезняти",
  "ImgUpCamError": "Камера недоступна. Дозвольте доступ у налаштуваннях браузера.",
  "ImgUpOriginalWarn": "Ви впевнені?",
  "ImgUpOriginalWarnText": "Оригінальний файл займає {size}. Після оптимізації буде ~{opt} — на {pct}% менше.",
  "ImgUpCompress": "Краще стиснути",
  "ImgUpUploadOriginal": "Все одно завантажити оригінал",
  "ImgUpProcessing": "Обробка…",

  // Settings — Users Management
  "SettingsUsersTitle": "Користувачі компанії",
  "ResetPassword": "Скинути пароль",
  "NewPassword": "Новий пароль",
  "PasswordMinLength": "Мінімум 6 символів",
  "EditRoles": "Змінити ролі",
  "RolesUpdated": "Ролі оновлено",
  "HrLeaveBalance": "Відпустки",
  "AnnualLeave": "Щорічна відпустка",
  "HrEntitlement": "Норма",
  "HrEntitlementBase": "Базова норма",
  "HrProRata": "Частина року",
  "HrAdjustment": "Коригування",
  "HrAdjustments": "Коригування",
  "HrPending": "Заплановано",
  "HrShowApproved": "Архів",
  "HrUsage": "Використання",
  "HrAmount": "Кількість",
  "HrUnit": "Одиниця",
  "HrLeaveYear": "Відпускний рік",
  "HrMainLeaveType": "Основний тип",
  "HrAdjKind": "Тип коригування",
  "HrAdjKind_carryover": "Перенесення",
  "HrAdjKind_bonus": "Бонус",
  "HrAdjKind_buy": "Купівля",
  "HrAdjKind_sell": "Продаж",
  "HrAdjKind_manual": "Вручну",
  "Employee": "Співробітник",
  "Deleted": "Видалено",
  "Pattern": "Патерн",
  "Prev": "Попередній",
  "Next": "Наступний",
  "HrLeaveRules": "Правила розрахунку відпустки",
  "HrLeaveYearStart": "Початок відпускного року",
  "HrLeaveUnitBasis": "Одиниця обліку",
  "HrUnitBasis_working_days": "Робочі дні",
  "HrUnitBasis_calendar_days": "Календарні дні",
  "HrUnitBasis_hours": "Години",
  "HrEntitlementFormula": "Формула норми",
  "HrFormula_weeks": "Тижні × годин/тиждень",
  "HrFormula_days": "Фіксовані дні",
  "HrFormula_hours": "Години",
  "HrEntitlementWeeks": "Тижнів / базових днів",
  "HrAccrualMode": "Режим нарахування",
  "HrAccrual_upfront": "Одразу (pro-rata)",
  "HrAccrual_monthly": "Помісячно (accrual)",
  "HrAccrualRate": "Ставка нарахування (дн/міс)",
  "HrRounding": "Округлення",
  "HrRound_none": "Немає",
  "HrRound_half_up": "Вгору до 0.5 дня",
  "HrRound_full_up": "Вгору до 1 дня",
  "HrRound_nearest_half": "До найближчих 0.5",
  "HrRound_tenth": "До 0.1",
  "HrCarryoverMax": "Ліміт перенесення (днів)",
  "HrHolidayPatternInfo": "Облік держсвят задається в робочому патерні.",
  "Month": "Місяць",
  "Day": "День",
  "HrSelectEmployee": "Виберіть співробітника, щоб побачити баланс відпустки",
  "HrAbsenceHistory": "Історія відсутностей",
  "Auto": "Авто",
  "HrUnitModeHint": "Авто бере одиницю з робочого патерна",
  "HrServiceLength": "Стаж",
  "HrHiredSince": "з",
  "HrNonWorkingDay": "Це неробочий день — його не можна забронювати",
  "HrTimeStep": "Крок часу",
  "HrTimeStepHint": "Застосовується до годин відпустки та таймшитів",
  "HrYearBasis": "База пропорційного розрахунку",
  "HrYearBasis_calendar": "Календарні дні (365 / 366 у високосний рік)",
  "HrYearBasis_working": "Робочі дні (пн–пт, ~261 на рік)",
  "HrYearBasisHint": "Знаменник для пропорційного розрахунку при наймі в середині року. «Робочі дні» відповідає системам нарахування зарплатні, що використовують 261 як базу року.",
  "HrLeaveCalc": "Розрахунок відпустки",
  "HrServiceBands": "Додаткові дні за стаж",
  "HrServiceBandsHint": "Додається автоматично до основного типу відпустки за датою найму",
  "HrServiceYears": "Стаж (років ≥)",
  "HrExtraDays": "Додаткові дні",
  "HrAddBand": "Додати рівень",
  "HrDirection": "Напрямок",
  "HrAdd": "Додати",
  "HrDeduct": "Списати",
  "HrHours": "Години",
  "HrMinutes": "Хвилини",
  "HrHowCalculated": "Як розраховано",
  "HrCalcBase": "База (за рік)",
  "HrCalcService": "Бонус за стаж",
  "HrYearsShort": "р",
  "HrMonthsShort": "міс",
  "HrEvent": "Подія",
  "HrCarryover": "Перенесення",
  "HrCarryoverAll": "Перенести всім",
  "HrCarryoverRemainder": "Перенести на",
  "HrHoursToCarry": "Годин до переносу",
  "HrToCarry": "До переносу",
  "HrCarriedOver": "Перенесено",
  "HrSkipped": "пропущено",
  "HrNothingToCarry": "Немає що переносити",
  "HrAlreadyCarried": "вже перенесено",
  "HrDeleted": "Видалено",
  "Ready": "Готово",
  "Driver": "Водій",
  "Drivers": "Водії",
  "Insurance": "Страхування",
  "Provider": "Страхова",
  "PolicyNumber": "Номер полісу",
  "ExpiryDate": "Термін дії",
  "CarExpenses": "Витрати на авто",
  "AddVehicle": "Додати авто",
  "EditVehicle": "Редагувати авто",
  "Expired": "Прострочено",
  "NotSet": "Не вказано",
  "AnyDriver": "Будь-який водій",
  "AnyEmployee": "Будь-який співробітник може керувати",
  "DefaultCar": "Авто за замовчуванням",
  "Petrol": "Бензин",
  "Diesel": "Дизель",
  "Electric": "Електро",
  "Hybrid": "Гібрид",
  "Personal": "Особисте",
  "Business": "Робоче",
  "Mixed": "Змішане",
  "You": "ви",
  "SelectCars": "Оберіть авто",
  "Document": "Документ",
  "AddPolicy": "Додати поліс",
  "EditPolicy": "Редагувати поліс",
  "CoveredVehicles": "Покриті авто",
  "SelectVehicles": "Оберіть авто",
  "NoVehicles": "Немає авто",
  "NoPolicies": "Немає полісів",
  "Contracts": "Контракти",
  "NewContract": "Новий контракт",
  "UploadContract": "Завантажити",
  "ContractTitle": "Назва контракту",
  "ContractTitlePlaceholder": "напр. Трудовий договір",
  "ContractFile": "Файл (PDF, DOCX)",
  "ContractSigned": "Підписано",
  "ContractPending": "Очікує підпису",
  "ContractDraft": "Чернетка",
  "NoContracts": "Немає контрактів",
  "SearchContracts": "Пошук контрактів…",
  "DropContractHere": "Перетягніть PDF або DOCX сюди, або натисніть для вибору",
  "DropContractSub": "Макс. 20 МБ · PDF, DOCX",
  "ElectronicSignature": "Електронний підпис",
  "DrawSignatureHint": "Намалюйте підпис для підтвердження документа",
  "SignHere": "Намалюйте підпис тут",
  "SignHereSub": "Використовуйте мишу або сенсорний екран",
  "SignatureCaptured": "Підпис зафіксовано",
  "SignAndSubmit": "Підписати та надіслати",
  "SignAs": "Підписує",
  "SignLegalNotice": "Натискаючи «Підписати та надіслати», ви підтверджуєте, що ознайомилися з документом і погоджуєтесь підписати його електронно. Цей підпис є юридично обов'язковим.",
  "BackToContracts": "Назад до контрактів",
  "ContractDraftNotice": "Цей контракт є чернеткою. Завантажте файл і надішліть на підпис.",
  "NoFileAttached": "Файл не прикріплено",
  "DeleteContractConfirm": "Видалити цей контракт?",
  "StepReview": "Перегляд",
  "StepSign": "Підпис",
  "StepSubmit": "Надіслати",
  "NoDrivers": "Немає водіїв",
  "Idle": "Неактивне",
  "DaysShort": "дн",
  "CurrentDocument": "Поточний документ",
  "BrowseDocument": "Завантажити документ",
  "TrainingPublished": "Опубліковано",
  "TrainingUnpublished": "Знято з публікації",
  "TrainingDraft": "Чернетка",
  "TrainingPublishToggleHint": "Перемкнути опубліковано / чернетка",
  "HrRebalanceTitle": "Перебалансування TOIL по тижнях",
  "HrWeeksToFix": "Тижнів до виправлення",
  "HrDeleteManual": "Видалити ручні",
  "HrRebalanceAll": "Перебалансувати все",
  "HrToilByWeek": "TOIL по тижнях",
  "HrPatternOfWeek": "Патерн тижня",
  "HrWeekBalance": "Баланс тижня",
  "HrChanges": "Зміни",
  "HrUsesToil": "З TOIL",
  "HrNoToil": "Без TOIL",
  "HrWeekPatternIs": "Патерн, що діє цього тижня",
  "HrWeekUsesToil": "Патерн використовує TOIL → переробіток іде в баланс TOIL. Report перераховується, зайва авто-корекція знімається, ручні корекції зберігаються.",
  "HrWeekNoToil": "Патерн НЕ використовує TOIL → переробіток обнуляється авто-корекцією, а всі ручні корекції цього тижня видаляються (вони дублюють залік).",
  "HrReportRecalc": "Report — перерахунок за патерном",
  "HrToilWasNow": "TOIL було → стало",
  "HrAutoCorrection": "Авто-корекція (обнулення переробітку)",
  "HrAction": "Дія",
  "HrManualOfWeek": "Ручні корекції тижня",
  "HrSum": "Сума",
  "HrWhatHappens": "Результат",
  "HrKeep": "залишити",
  "HrRebalanceWeek": "Перебалансувати тиждень",
  "HrCreate": "створити",
  "HrUpdate": "оновити",
  "HrRebalanceNote": "Кожне застосування пише запис в аудит-лог. Нічого не змінюється без підтвердження.",
  "HrRecalcReportLine": "Перерахувати report за патерном",
  "HrManualCorr": "Ручна корекція",
  "HrWeekResult": "Результат тижня",
  "HrRebalanceAllBody": "Усі тижні нижче буде перебалансовано одразу, а річну відпустку перераховано.",
  "HrWeeksToRebalance": "тижнів до перебалансування",
  "HrManualToDelete": "ручних корекцій до видалення",
  "HrLeaveToRecalc": "періодів відпустки до перерахунку",
  "HrRebalance": "Перебалансувати",
  "DriverLicence": "Посвідчення водія",
  "LicenceNotAdded": "Не додано",
  "Until": "до",
  "LicenceNumber": "Номер посвідчення",
  "LicenceCategories": "Категорії (типи авто)",
  "SelectCategories": "Оберіть категорії",
  "LicencePhotos": "Фото посвідчення",
  "TwoSides": "лицьова та зворотна",
  "FrontSide": "Лицьова сторона",
  "BackSide": "Зворотна сторона",
  "UploadPhoto": "Завантажити фото",
  "LicenceHint": "Усі поля та обидва фото обов'язкові. Під час створення витрати на авто система перевіряє, що посвідчення додане та дійсне.",
  "LicencePhotosRequired": "Потрібні обидва фото посвідчення",
  "NoLicence": "Немає посвідчення",
  "LicenceOk": "Посвідчення",
  "LicenceExpiredShort": "Посвідчення прострочене",
  "MyLicence": "Моє посвідчення",
  "FromWhom": "Від кого",
  "ClaimDateLimits": "Обмеження дат заявок",
  "ClaimDaysHint": "Встановіть максимальну кількість днів у минулому, яку працівник може вибрати при поданні заявки. Залиште порожнім, щоб дозволити будь-яку дату.",
  "ExpensesClaimDays": "Витрати — максимум днів назад",
  "ExpensesClaimDaysHint": "напр. 30 — чеки мають бути подані протягом 30 днів від покупки",
  "CarExpensesClaimDays": "Витрати на авто — максимум днів назад",
  "CarExpensesClaimDaysHint": "напр. 30 — заявки на пробіг мають бути подані протягом 30 днів",
  "SelectEmployee": "Оберіть співробітника",
  "NoEmployeesWithoutLicense": "Всі співробітники вже мають посвідчення",
  "HrMyRequest": "Моя заявка",
  "HrForEmployee": "Для {{name}} · додано HR",
  "Optional": "необов'язково",
  "HrNotePlaceholder": "Додайте коментар для керівника",
  "HrResetFullDay": "Повний день",
  "HrFitNote": "Лікарняний",
  "HrAttachment": "Вкладення",
  "HrDropFile": "Перетягніть файл сюди або",
  "HrBrowse": "оберіть",
  "HrFileTypes": "PDF, JPG або PNG · до 10 МБ",
  "HrFitNoteRequired": "Для відсутності понад 7 днів потрібен лікарняний",
  "HrDaysShort": "дн.",
  "HrEndBeforeStart": "Кінець раніше за початок",
  "HrOverBalance": "Недостатньо залишку для цієї заявки",
  "HrWorkingDaysN_one": "{{count}} робочий день",
  "HrWorkingDaysN_few": "{{count}} робочі дні",
  "HrWorkingDaysN_many": "{{count}} робочих днів",
  "HrWorkingDaysN_other": "{{count}} робочих днів",
  "HrSendRequest": "Надіслати заявку",
  "HrLeftAfterRequest": "Залишиться {{left}} з {{total}} {{unit}}"
}
